// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__4APZA","content":"Dialog_content__fCcHL"};